"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.values = exports.keys = void 0;
/**
 * `Object.keys`, but typed!
 * @param o Some key:value object
 */
const keys = (o) => Object.keys(o);
exports.keys = keys;
/**
 * `Object.values`, but typed!
 * @param o Some key:value object
 */
const values = (o) => Object.values(o);
exports.values = values;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy1hbmQtdmFsdWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2tleXMtYW5kLXZhbHVlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7O0dBR0c7QUFDSSxNQUFNLElBQUksR0FBRyxDQUFtQyxDQUFJLEVBQUUsRUFBRSxDQUM3RCxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBZ0IsQ0FBQztBQURuQixRQUFBLElBQUksUUFDZTtBQUVoQzs7O0dBR0c7QUFDSSxNQUFNLE1BQU0sR0FBRyxDQUFtQyxDQUFJLEVBQUUsRUFBRSxDQUMvRCxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBaUIsQ0FBQztBQUR0QixRQUFBLE1BQU0sVUFDZ0IifQ==